/* RecommendedSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._42d1HAlA6J%7Brow-gap%3Acalc(var(--ds-space-800%2C%204pc)%20-%20var(--ds-space-100%2C%208px))%7D");
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import HeadingSkeleton from '@atlaskit/skeleton';
import { AgentCardSkeleton } from '@atlassian/studio-browse-kit/agent-card-skeleton';
import { HeroCardSkeleton } from '@atlassian/studio-browse-kit/common/ui/HeroCard/HeroCardSkeleton';
import { CardList } from '@atlassian/studio-browse-kit/ui/card-list';
import { HeroCardList } from '@atlassian/studio-browse-kit/ui/hero-card-list';
import { RECOMMENDED_SLOT_COUNT, UPLIFT_RECOMMENDED_SLOT_COUNT } from '../RecommendedList/buildRecommendedItems';
import { RecommendedPanel } from '../RecommendedList/Components/RecommendedPanel/RecommendedPanel';
const styles = {
  sections: "_42d1HAlA6J"
};
const UPLIFT_SECTIONS = ([{
  id: 'recommended',
  count: UPLIFT_RECOMMENDED_SLOT_COUNT,
  columns: 2,
  CardSkeleton: HeroCardSkeleton
}, {
  id: 'coding-agents',
  count: 4,
  columns: 4,
  CardSkeleton: AgentCardSkeleton
}, {
  id: 'recommended-agents',
  count: 4,
  columns: 4,
  CardSkeleton: AgentCardSkeleton
}, {
  id: 'templates',
  count: 4,
  columns: 4,
  CardSkeleton: AgentCardSkeleton
}] as const);
const skeletonRecommendedKeys = Array.from({
  length: RECOMMENDED_SLOT_COUNT
}, (_, index) => `recommended-skeleton-card-${index}`);
export const RecommendedSkeleton = ({
  testId
}: {
  testId?: string;
}): React.JSX.Element => {
  if (fg('rovo_agents_studio_browse_kit_uplift')) {
    return <Stack xcss={styles.sections} aria-hidden="true" testId={testId}>
				{UPLIFT_SECTIONS.map(({
        id,
        count,
        columns,
        CardSkeleton
      }) => {
        const cards = Array.from({
          length: count
        }, (_, index) => <CardSkeleton key={`${id}-skeleton-card-${index}`} testId={testId ? `${testId}--${id}-card-${index}` : undefined} />);
        return <Stack key={id} space="space.200">
							<Stack space="space.050">
								<HeadingSkeleton width={160} height={20} />
								<HeadingSkeleton width="60%" height={16} />
							</Stack>
							{id === 'recommended' ? <HeroCardList testId={testId ? `${testId}--${id}-items` : undefined}>
									{cards}
								</HeroCardList> : <CardList columns={columns} testId={testId ? `${testId}--${id}-items` : undefined}>
									{cards}
								</CardList>}
						</Stack>;
      })}
			</Stack>;
  }
  return <Stack space="space.200">
			<Inline alignBlock="center">
				<HeadingSkeleton width={80} height={20} isShimmering />
			</Inline>
			<RecommendedPanel testId={testId ? `${testId}--recommended` : undefined}>
				<CardList columns={2} testId={testId ? `${testId}--recommended-items` : undefined}>
					{skeletonRecommendedKeys.map((key, index) => <AgentCardSkeleton key={key} testId={testId ? `${testId}--recommended-card-${index}` : undefined} />)}
				</CardList>
			</RecommendedPanel>
		</Stack>;
};